module.exports = __webpack_public_path__ + "img/sports_2.48c5d441.jpg";